import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3c85e8ff"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "technologies-container"
};
const _hoisted_2 = {
  class: "technologies-list"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "technologies-item-subtitle"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iconpark-icon", {
  name: "jiantou",
  size: "32"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Title = _resolveComponent("Title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Title, {
    title: "Enjoy new technologies and experience <br> new things"
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["technologies-item", item.class]),
      key: index
    }, [_createElementVNode("div", {
      class: "technologies-item-title",
      innerHTML: item.title
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.subtitle), 1), _createElementVNode("div", {
      class: "technologies-item-btn",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.goEditor && _ctx.goEditor(...args))
    }, _hoisted_6)], 2);
  }), 128))])]);
}